
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/account/current-subscriptions",
      function () {
        return require("private-next-pages/[region]/[lang]/account/current-subscriptions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/account/current-subscriptions"])
      });
    }
  